import { map, forEach, values } from 'lodash';
import {
  FETCH_COMMISSION_ALL_SUCCEED,
  FETCH_COMMISSION_BY_TIME_SUCCEED,
  FETCH_COMMISSION_USER_BY_TIME_SUCCEED,
  FETCH_COMMISSION_USER_SUCCEED,
  FETCH_COMMISSION_USERS_PAGINATE_SUCCEED,
  FETCH_TOTAL_REFERRAL_SUCCEED,
  FETCH_LIST_MAP_LEVEL_SUCCEED,
  FETCH_LIST_PARTNERS_SUCCEED,
} from '../actions/commission/action_types';

export default (
  state = {
    commissions: [],
    userCommission: [],
    usersCommission: [],
    totalReferral: [],
    listMapLevel: [],
    listPartners: [],
  }, action,
) => {
  switch (action.type) {
    case FETCH_COMMISSION_ALL_SUCCEED:
      return {
        ...state,
        commissions: action.data || [],
      };
    case FETCH_COMMISSION_BY_TIME_SUCCEED:
      return {
        ...state,
        commissions: action.data || [],
      };
    case FETCH_COMMISSION_USER_SUCCEED:
      return {
        ...state,
        userCommission: action.data || [],
      };
    case FETCH_COMMISSION_USER_BY_TIME_SUCCEED:
      return {
        ...state,
        userCommission: action.data || [],
      };
    case FETCH_COMMISSION_USERS_PAGINATE_SUCCEED:
      return {
        ...state,
        usersCommission: map(action.data, (item) => {
          item.key = item.pubkey;
          item.list_coin_arr = map(item.list_coin, (value, key) => (
            { name_coin: key, value }
          ));
          return item;
        }),
      };
    case FETCH_TOTAL_REFERRAL_SUCCEED:
      return {
        ...state,
        totalReferral: action.data || 0,
      };
    case FETCH_LIST_MAP_LEVEL_SUCCEED:
      return {
        ...state,
        listMapLevel: map(action.data, (item) => {
          item.key = item.level;
          return item;
        }),
      };
    case FETCH_LIST_PARTNERS_SUCCEED:
      return {
        ...state,
        listPartners: action.data,
        totalCountPartner: action.totalCount,
      };
    default:
      return {
        ...state,
      };
  }
};
